import { render, staticRenderFns } from "./SupplierStockComponent.vue?vue&type=template&id=1f2edd76&"
import script from "./SupplierStockComponent.vue?vue&type=script&lang=js&"
export * from "./SupplierStockComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports